"use client"

import { useFormContext } from "react-hook-form"
import { PostAJobModalFormValues } from "./types"
import { useSkillsFilter } from "../Filters/hooks/useSkillsFilter"
import { Button, Text } from "@/elements"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { useCallback } from "react"
import { DropDownItem, TextInputWithDropdown } from "../TextInputWithDropdown"

export const SkillsInput: React.FC = () => {
  const { setValue, watch } = useFormContext<PostAJobModalFormValues>()
  const displayValue = watch("skillsInputValue")
  const existingSkills = watch("skills")
  const skills = useSkillsFilter()

  const searchedSkills = skills.filter(edge => edge?.node?.name.toLowerCase().includes(displayValue.toLowerCase()))

  const dropDownItems = searchedSkills?.map(r => {
    return {
      id: r?.node?.id!,
      display: r?.node?.name!,
    }
  })

  const onClickDropDownItem = (item: DropDownItem) => {
    if (existingSkills.some(skill => skill.id === item.id)) {
      return
    }

    setValue("skills", [
      ...existingSkills,
      {
        id: item.id,
        name: item.display,
      },
    ])

    setValue("skillsInputValue", "")
  }

  const onRemoveSkill = (id: string) => {
    setValue(
      "skills",
      existingSkills.filter(skill => skill.id !== id)
    )
  }

  return (
    <div>
      <Text variant="body2" className="mb-2 text-fg-2">
        Skills (optional)
      </Text>
      <div className="rounded-md border border-bg-3">
        <TextInputWithDropdown
          size="small"
          className="flex flex-1 flex-row"
          dropDownClassName="max-h-[350px]  overflow-scroll"
          labelClassName="text-fg-2 mb-0"
          inputProps={{
            placeholder: "Add skills",
            onChange: e => setValue("skillsInputValue", e.target.value),
            className: "border-none text-body2-md lg:text-body2-lg p-3 py-3",
          }}
          closeMenuOnSelect
          dropdownItems={dropDownItems}
          id="skills-input"
          inputValue={displayValue}
          onClickDropDownItem={onClickDropDownItem}
          dropdownPosition="above"
        />

        <div className="mt-0 flex flex-row flex-wrap gap-2 p-3">
          {existingSkills?.map(skill => {
            return (
              <div
                className="flex flex-shrink-0 cursor-pointer items-center rounded-sm bg-bg-3 px-2 py-1"
                key={skill.id}
                onClick={() => onRemoveSkill(skill.id)}>
                <Text variant="body2">{skill.name}</Text>
                <XMarkIcon className="ml-2 stroke-fg-2" height={16} width={16} />
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}
